<template>
    <svg id="man-svg"viewBox="0 0 508 508">
        <g id="man-portrait">
            <circle cx="254" r="254" cy="254" fill="#90DFAA"/>
            <g fill="#E6E9EE">
                <path d="m255 363c-0.4 0-0.8 0.4-1.6 0.4-0.4 0-0.8-0.4-1.6-0.4h4z"/>
                <path d="m458 404c-46 62.8-121 104-205 104s-158-41-204-104c36-38.4 84.8-58.8 126-69.2-3.6 29.2 11.6 68.4 12 67.2 15.2-35.2 66.8-38.4 66.8-38.4s51.6 2.8 67.2 38.4c0.4 0.8 15.6-38 12-67.2 41 10 89 31 125 69z"/>
            </g>
            <path d="m317 308c0 5.2-3.2 32.8-61.6 55.2h-3c-58.4-22.4-61.6-50-61.6-55.2 0.4-10.4 2.8-20.8 7.2-30.4 16 18 35.2 30 56 30 20.4 0 40-11.6 56-30 5 9 8 20 8 30z" fill="#FFD05B"/>
            <path :fill="tieColor1" d="m288 372l-12 26h-44l-12.8-25.6c17.6-7.6 34.8-8.8 34.8-8.8s17 2 34 9z" />
            <path :fill="tieColor2" d="m218 506c11.6 1.6 23.6 2.4 36 2.4 12 0 24-0.8 36-2.4l-14-107h-44l-14 107z" />
            <g fill="#fff">
                <path d="m317 307s2.8 32-63.2 56.4c0 0 51.6 2.8 67.2 38.4 0 3 30-75-4-94z"/>
                <path d="m190 307c-34 18.8-4.4 96-3.6 94.8 15.2-35.2 67.2-38.4 67.2-38.4-65-25-63-57-63-57z"/>
            </g>
            <path d="m313 286c-16.8 18-36.8 29.6-59.2 29.6s-42.4-11.6-59.2-29.6c0.8-2.8 2-5.6 3.2-8 16 18 35.2 30 56 30s40-11.6 56-30c1 2 2 5 3 8z" fill="#F9B54C"/>
            <path d="m363 224c-8.4 14-21.2 22.4-30.8 20.8-19.2 35.6-47.2 62-78.4 62s-59.2-26.8-78.4-62c-9.6 1.2-22.4-6.8-30.8-20.8-10-16.4-10.4-34.4-0.8-40.4 2.4-1.2 4.8-2 7.6-1.6 6.4 16.4 15.2 26.4 15.2 26.4-9.2-50.8 28.4-56.4 22-105 0 0 23.6 52.4 91.2 15.6l-5.2 10c94.4-21.2 62.8 90 62 92.8 10.8-13.6 17.6-27.2 21.6-39.6 1.6 0 3.6 0.8 4.8 1.6 9 6 9 24-1 40z" fill="#FFD05B"/>
            <path fill="#333" d="m308 50.8c7.6-0.8 20 6 20 6-34-38.8-89.6-14-89.6-14 18.8-16 35.6-14.4 35.6-14.4-79.6-12-93.2 35.6-93.2 35.6-3.6-5.6-3.6-13.6-3.2-17.6-6 9.6 0 28.8 0 28.8-5.6-14-25.2-11.6-25.2-11.6 16.8 2.8 19.6 13.2 19.6 13.2-42 15.6-34.8 59.2-34.8 59.2l10-12c-12.4 47.6 19.2 84.4 19.2 84.4-9.2-50.8 28.4-56.4 22-105 0 0 23.6 52.4 91.2 15.6l-5.2 10c95.6-21.6 62 93.2 62 93.2 34-43.2 28.8-87.6 28.8-87.6l4 16c10-71.6-62-99.2-62-99.2z"/>
        </g>
    </svg>
</template>

<script>
import mapState from 'vuex'
export default {
    name:'main-man-portrait',
    computed: {
        tieColor1(){
            return this.$store.getters.currentGradient[0]
        },
        tieColor2(){
            return this.$store.getters.currentGradient[1]
        }
    }
}

</script>

<style lang="scss" scoped>

#man-portrait{
    visibility: inherit;
}

#man-portrait *{
    transition: 1.5s;
}

</style>